var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.plans.length > 0)?_c('travel-preview',{attrs:{"plan-preview":_vm.plans[0]}}):_c('travel-preview'),_c('section',[_c('tabs-navigation',{attrs:{"current-tab":'future'}}),_c('div',{staticClass:"tabs__content"},[_c('tab-content-future',{attrs:{"user-plans":_vm.plans}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }